import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start" }
const _hoisted_3 = { class: "nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Archivio")
const _hoisted_6 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://github.com/Minettyx/CCM",
    class: "nav-link px-2 link-dark",
    style: {"cursor":"pointer"},
    target: "_blank",
    rel: "noreferrer"
  }, "GitHub")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://paypal.me/pools/c/8ru3kh05Tu",
    class: "nav-link px-2 link-dark",
    style: {"cursor":"pointer"},
    target: "_blank",
    rel: "noreferrer"
  }, "Donazioni")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://t.me/ccmtranslations",
    class: "nav-link px-2 link-dark",
    style: {"cursor":"pointer"},
    target: "_blank",
    rel: "noreferrer"
  }, "Telegram")
], -1)
const _hoisted_9 = { class: "nav col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3 justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_fai = _resolveComponent("fai")

  return (_openBlock(), _createBlock("header", {
    class: ["p-1 mb-3 border-bottom bg-white", {'sticky-top': _ctx.viewport>=3}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("ul", _hoisted_3, [
          _createVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "nav-link px-2 link-secondary",
              style: {"cursor":"pointer"}
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _createVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/archive",
              class: "nav-link px-2 link-dark",
              style: {"cursor":"pointer"}
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8
        ]),
        _createVNode("ul", _hoisted_9, [
          _createVNode("li", null, [
            _createVNode("a", {
              class: "nav-link px-2 link-dark",
              style: {"cursor":"pointer"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.darkmode = !_ctx.darkmode))
            }, [
              _createVNode(_component_fai, {
                icon: _ctx.darkmode ? 'sun' : 'moon'
              }, null, 8, ["icon"])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}